// Shopmonkey deep links.
//
// A customer's own page is app.shopmonkey.cloud/customer/<id>, where <id> is
// the customer's id in the Shopmonkey data stream (EDS `customer.id`): a uuid
// for records created on the current platform, a 24-character hex id for the
// ones carried over from the old one. Anything else (a Dig "osr:" lead id, a
// blank) has no Shopmonkey page.

const SHOPMONKEY_ID_RE = /^([0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}|[0-9a-f]{24})$/i;

export const isShopmonkeyId = (id) => SHOPMONKEY_ID_RE.test(String(id || ""));

export const shopmonkeyCustomerUrl = (id) => `https://app.shopmonkey.cloud/customer/${id}`;

// An order's page (estimate, repair order or invoice) is app.shopmonkey.cloud/order/<id>, the EDS `order.id`.
export const shopmonkeyOrderUrl = (id) => `https://app.shopmonkey.cloud/order/${id}`;

// A Poseidon Live row's order: a Chariot one (`source: 'chariot'`, a market on
// Chariot — orders overhaul Phase 5) opens in Chariot, the rest in Shopmonkey.
export const liveOrderUrl = (row) => (row?.source === "chariot" ? `/app/orders/${row.order_id}` : shopmonkeyOrderUrl(row?.order_id));
